module.exports = __webpack_public_path__ + "img/image41.ef55e814.png";